import React, { useState, useEffect, useRef } from 'react';
import GoogleMapReact from 'google-map-react';

import { Row } from 'antd';

import MarkerMap from './MarkerMap';

import './GoogleMapViewUserLocation.less';

export const isValidCoords = (lat, lng) => {
  const parsedLat = parseFloat(lat);
  const parsedLng = parseFloat(lng);
  return (
    !isNaN(parsedLat) && !isNaN(parsedLng) && parsedLat !== 0 && parsedLng !== 0
  );
};

const DEFAULT_CENTER = { lat: 34.0522, lng: -118.2437 };

const GoogleMapViewUserLocation = (props) => {
  const { loadingOffice, centerData } = props;
  const [places, setPlaces] = useState([]);
  const [mapId, setMapId] = useState(false);

  const [centerMap, setCenterMap] = useState(() => {
    if (isValidCoords(centerData?.latitude, centerData?.longitude)) {
      return {
        lat: parseFloat(centerData.latitude),
        lng: parseFloat(centerData.longitude),
      };
    }
    return DEFAULT_CENTER;
  });

  const [zoomMap, setZoomMap] = useState(12);
  const [mapLoaded, setMapLoaded] = useState(false);

  const addressRef = useRef(null);

  useEffect(() => {
    if (
      !centerData ||
      !isValidCoords(centerData.latitude, centerData.longitude)
    )
      return;

    const lat = parseFloat(centerData.latitude);
    const lng = parseFloat(centerData.longitude);

    setPlaces([
      {
        ...centerData,
        latitude: lat,
        longitude: lng,
        show: false,
        hover: false,
      },
    ]);
    setCenterMap({ lat, lng });
  }, [centerData]);

  const onBoundsChange = (center, zoom) => {
    setZoomMap(zoom);
  };

  const onChildClickCallback = (key) => {
    handleShowInfoAndSelectedItem(key);
  };

  const onCloseInfoWindow = () => {
    setPlaces((prev) => prev.map((val) => ({ ...val, show: false })));
    setMapId(false);
  };

  const handleShowInfoAndSelectedItem = (id) => {
    let indexScroll = 0;
    const updatedPlaces = places.map((val, index) => {
      if (val?.id?.toString() === id?.toString()) {
        const lat = parseFloat(val.latitude);
        const lng = parseFloat(val.longitude);
        if (!isNaN(lat) && !isNaN(lng)) {
          setCenterMap({ lat, lng });
        }
        indexScroll = index;
        return { ...val, show: true };
      }
      return { ...val, show: false };
    });
    setPlaces(updatedPlaces);
    setMapId(id);
    if (addressRef.current) addressRef.current.scrollTop = indexScroll * 126;
  };

  const handleApiLoaded = (map, maps) => {
    setMapLoaded(true);
  };

  if (
    !centerData ||
    !isValidCoords(centerData.latitude, centerData.longitude)
  ) {
    return null;
  }

  return (
    <Row style={{ height: '100%', width: '100%' }}>
      <Row style={{ flex: 3 }}>
        <GoogleMapReact
          defaultZoom={12}
          center={centerMap}
          bootstrapURLKeys={{
            key: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
          }}
          //use this api to open google map for testing in local
          onChildClick={onChildClickCallback}
          onBoundsChange={onBoundsChange}
          onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
          key={mapLoaded}
        >
          {places &&
            mapLoaded &&
            places.length > 0 &&
            places.map((place) => {
              const lat = parseFloat(place?.latitude);
              const lng = parseFloat(place?.longitude);

              if (!place || isNaN(lat) || isNaN(lng)) return null;

              return (
                <MarkerMap
                  key={place.id}
                  // lat={lat}
                  // lng={lng}
                  show={place.show}
                  hover={place.hover}
                  place={place}
                  style={{ width: 27, height: 43 }}
                  zoomMap={zoomMap}
                  onCloseInfoWindow={onCloseInfoWindow}
                />
              );
            })}
        </GoogleMapReact>
      </Row>
    </Row>
  );
};

export default GoogleMapViewUserLocation;
